import { handleResponse, handleError, authHeader } from "./apiUtils";
import axios from "axios";
import { API_ROOT } from "./api-config";

const base = API_ROOT + "aprconfg/";

export function getAPRConfgSubject() {
  return axios({
    method: "GET",
    url: base + "GetAPRConfgSubject",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getAPRConfgUser() {
  return axios({
    method: "GET",
    url: base + "GetAPRConfgUser",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getAPRConfg(userKey) {
  return axios({
    method: "GET",
    url: base + "GetAPRConfg",
    headers: authHeader(),
    params: { key: userKey }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function updateAPRConfg(aprConfg) {
  return axios({
    method: "PUT",
    url: base + "UpdateAPRConfg",
    headers: authHeader(),
    data: aprConfg
  })
    .then()
    .catch(handleError);
}
